import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "./../../../actions"
import {
    Icon,
    TextField,
    Toast,
    Heading,
    List,
    ChoiceList,
    RangeSlider,
    Select,
    Card,
    Button,
    RadioButton,
    Stack,
} from "@shopify/polaris"
import IconList from "../../IconList"
import "./styles.scss"
import Switch from "react-switch"
import { RefreshMinor } from "@shopify/polaris-icons"
import Preloader from "../../Preloader"
import Preloader2 from "../Preloader"
import { iconsSet } from "../../AppCont/icons_set"
import ColorSettings from "../../ColorSettings"
import axios from "../../../funcs/axios"
import { QuestionMarkMinor } from "@shopify/polaris-icons"
let clientUrl1 = "nautilus-puzzles.myshopify.com"
let clientUrl2 = "nhkstore1412.myshopify.com"

function mapStateToProps(state) {
    return {
        widget_selected: state.widget_selected,
        pages: state.pages,
        app_settings: state.app_settings,
        widgets: state.widgets,
        app_render: state.app_render,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
window.check = false
class TemplateCustom extends Component {
    constructor(props) {
        super(props)
        // INITIAL_STATE.app_settings = props.app_settings;
        // this.state = Object.assign({}, INITIAL_STATE);
        this.searchTimeout = null
    }
    componentWillUnmount() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
    }

    loadCustomCss() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-metafields-custom-css`).then((res) => {
            console.log("res :>> ", res)
            if (res.data.customCSS.length)
            {
              console.log("string", JSON.parse(res.data.customCSS[0].value).customCss)
              this.setState({ customCss: JSON.parse(res.data.customCSS[0].value).customCss })
            }
        })
    }

    loadProduct = () => {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-first-product`).then((res) => {
            let data = res.data.products
            console.log("data loadProduct :>> ", data)
            this.setState({ product: data[0] })
        })
    }

    state = {
        app_settings: JSON.parse(JSON.stringify(this.props.app_render)),
        tabSelected: 0,
        layoutTabs: [],
        layoutTabsShowWl: [
            {
                label: "Modify the launch point",
                show: true,
            },
            {
                label: "Show Button Styles",
                show: false,
            },
        ],
        layoutTabsAddWlPage: [
            {
                label: "Modify the launch point",
                show: true,
            },
            {
                label: "Show Button Styles",
                show: false,
            },
            {
                label: "Selector",
                show: false,
            },
        ],

        layoutTabsAddWl: [
            {
                label: "Modify the launch point",
                show: true,
            },
            {
                label: "Show Button Styles",
                show: false,
            },
        ],
        layoutTabsDelete: [
            {
                label: "Remove Button",
                show: true,
            },
        ],
        advancedTabs: {
            label: "Appearance",
            show: true,
        },
        colorsTabs: [
            {
                label: "Show Button",
                show: true,
            },
            {
                label: "Add Button",
                show: true,
            },
        ],
        pointTypeSetting: {
            type: "floating",
            placement: [
                { label: "Bottom Right", value: "Bottom Right" },
                { label: "Bottom Left", value: "Bottom Left" },
                { label: "Right", value: "Right" },
                { label: "Left", value: "Left" },
            ],
        },
        selectorTypeSetting: {
            type: "top",
            placement: [
                { label: "Top", value: "Top" },
                { label: "Bottom", value: "Bottom" },
            ],
        },
        appWaiting: false,
        toast: {
            error: false,
            content: "",
            show: false,
        },
        source_url: {
            value: "",
            errMsg: "",
        },
        isLoading: false,
        // Define default icons set
        iconsSet: iconsSet,
        wishlist_settings_edited: [],
        compare_settings_edited: [],
        general_settings_edited: [],
        saveState: false,
        showPrivacy: false,
        errorValidate: {
            error_1: "", // wishlist add class error
            error_2: "", // wishlist show class error
            error_2a: "", // wishlist remove class error
            error_3: "", // compare add class error
            error_4: "", // compare show class error
            error_4a: "", // compare remove class error
        },
        product: {},
        customCss: "",
    }

    /**
     * Cache edited setting
     */
    cacheSetting(type: String, editObj: Object) {
        const settingKey =
            type === "wishlist"
                ? "wishlist_settings"
                : type === "compare"
                ? "compare_settings"
                : "general_settings"
        const editObjKey = Object.keys(editObj)[0]
        const editObjVal = Object.values(editObj)[0]
        const { app_settings, actions } = this.props
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            this.state
        const handleList =
            type === "wishlist"
                ? wishlist_settings_edited
                : type === "compare"
                ? compare_settings_edited
                : general_settings_edited
        const handleKey =
            type === "wishlist"
                ? "wishlist_settings_edited"
                : type === "compare"
                ? "compare_settings_edited"
                : "general_settings_edited"
        const propObjVal = app_settings[settingKey][editObjKey]
        let compareFlag = false
        if (!Array.isArray(editObjVal)) {
            // Normal value
            if (typeof editObjVal !== "object") {
                if (editObjVal === propObjVal) {
                    compareFlag = true
                }
            }
            // Object value
            else {
                if (
                    JSON.stringify({
                        ...this.state.app_settings[settingKey][editObjKey],
                        ...editObjVal,
                    }) === JSON.stringify(propObjVal)
                ) {
                    compareFlag = true
                }
            }
        } else {
            editObjVal.sort()
            propObjVal.sort()
            if (editObjVal.join() === propObjVal.join()) {
                compareFlag = true
            }
        }

        let newList = []
        let checkItemExisted = handleList.findIndex((item) => {
            let itemKey = Object.keys(item)[0]
            return itemKey === editObjKey
        })

        if (!compareFlag) {
            if (checkItemExisted !== -1) {
                newList = handleList.map((item) => {
                    let itemKey = Object.keys(item)[0]
                    if (itemKey === editObjKey) {
                        if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                            return {
                                [editObjKey]: {
                                    ...this.state.app_settings[settingKey][editObjKey],
                                    ...editObjVal,
                                },
                            }
                        } else {
                            return editObj
                        }
                    } else {
                        return item
                    }
                })
            } else {
                if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                    newList = handleList.concat([
                        {
                            [editObjKey]: {
                                ...this.state.app_settings[settingKey][editObjKey],
                                ...editObjVal,
                            },
                        },
                    ])
                } else {
                    newList = handleList.concat([editObj])
                }
            }
        } else {
            newList = handleList.filter((item) => {
                let itemKey = Object.keys(item)[0]
                return itemKey !== editObjKey
            })
        }

        this.setState({
            [handleKey]: newList,
        })
        actions.changeAppEditedAction(handleKey, newList)
        this.changeSetting()
    }

    /**
     * Change show class button setting function
     */
    showClassSettings(val: String, type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_show_class: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { wishlist_show_class: val })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_show_class: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_show_class: val })
        }
    }

    /**
     * Change add class button setting function
     */
    addClassSettings(val: String, type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_add_class: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { wishlist_add_class: val })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_add_class: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_add_class: val })
        }
    }

    /**
     * Change remove class button setting function
     */
    removeClassSettings(val: String, type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_remove_class: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { wishlist_remove_class: val })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_remove_class: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_remove_class: val })
        }
    }

    /**
     * Change icon settings
     */
    updateIconSettings(setting_type: String, icon_type: String, updateObj: Object) {
        const { actions } = this.props
        const { app_settings } = this.state
        let newWidget = Object.assign({}, app_settings)
        newWidget[setting_type][icon_type] = { ...newWidget[setting_type][icon_type], ...updateObj }
        this.setState({
            app_settings: newWidget,
        })

        this.cacheSetting(setting_type.replace("_settings", ""), {
            [icon_type]: {
                ...newWidget[setting_type][icon_type],
                ...updateObj,
            },
        })
    }

    /**
     * Change Product Amount setting function
     */
    productNumberSettings(val: Number, type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_product_number: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { wishlist_product_number: val })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_product_number: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_product_number: val })
        }
    }

    productNumberShowSettings(val: Number, type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        records_per_page: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { records_per_page: val })
        }
    }

    /**
     * Change Enable setting function
     */
    enableSettings(type: String) {
        if (type === "wishlist") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        wishlist_enable: !this.state.app_settings.wishlist_settings.wishlist_enable,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", {
                wishlist_enable: !this.state.app_settings.wishlist_settings.wishlist_enable,
            })
        } else {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_enable: !this.state.app_settings.compare_settings.compare_enable,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", {
                compare_enable: !this.state.app_settings.compare_settings.compare_enable,
            })
        }
    }

    /**
     * Change options setting function
     */
    optionSettings(val: Array<String>, name: String, type: String) {
        if (type === "compare") {
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        compare_options: val,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { compare_options: val })
        }
    }
    componentDidMount() {
        this.loadCustomCss()
        const { widget_selected, app_settings, pages } = this.props
        const { layoutTabsShowWl, layoutTabsAddWl, layoutTabsAddWlPage, layoutTabsDelete } =
            this.state
        // this.props.onRef(this);
        switch (widget_selected.id) {
            case 0:
                this.setState({ layoutTabs: layoutTabsShowWl })
                break
            case 1:
                this.setState({ layoutTabs: layoutTabsAddWl })
                break
            case 2:
                this.setState({ layoutTabs: layoutTabsAddWlPage })
                break
            case 3:
                this.setState({ layoutTabs: layoutTabsDelete })
                break
            default:
                break
        }
        this.loadProduct()
    }

    /**
     * Change update state app setting function
     */
    updateSelector(val: Array<String>, name: String, type: String) {
        const { widget_selected } = this.props
        const { app_settings } = this.state
        const { wishlist_settings, compare_settings } = app_settings
        let temp = widget_selected.id == 0 ? "show_selector" : "add_selector"

        if (type === "compare") {
            let selector =
                widget_selected.id == 0
                    ? compare_settings.show_selector
                    : compare_settings.add_selector
            selector[name] = val
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    compare_settings: {
                        ...this.state.app_settings.compare_settings,
                        [temp]: selector,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("compare", { [temp]: selector })
        } else {
            let selector =
                widget_selected.id == 0
                    ? wishlist_settings.show_selector
                    : wishlist_settings.add_selector
            selector[name] = val
            this.setState({
                app_settings: {
                    ...this.state.app_settings,
                    wishlist_settings: {
                        ...this.state.app_settings.wishlist_settings,
                        [temp]: selector,
                    },
                },
            })
            // Cache edited setting
            this.cacheSetting("wishlist", { [temp]: selector })
        }
    }

    renderTabComponent = () => {
        const { pages } = this.props
        const { tabSelected } = this.state
        if (pages.selected == 1) {
            switch (tabSelected) {
                case 0:
                    return this.renderLayout()
                // case 1:
                //     return this.renderAdvanced()
                // case 2:
                //     return this.renderSelector()
                default:
                    return this.renderLayout()
            }
        } else {
            switch (tabSelected) {
                case 0:
                    return this.renderLayout()
                default:
                    return this.renderLayout()
            }
        }
    }

    rendenLayoutCollapse = (index) => {
        const { widget_selected, pages } = this.props
        switch (widget_selected.id) {
            case 0: {
                switch (index) {
                    case 0:
                        return this.renderLayoutLaunchShowButton()
                    case 1:
                        return pages.selected == 1
                            ? this.renderLayoutShowButtonWishlist()
                            : this.renderLayoutShowButtonCompare()
                    default:
                        return
                }
            }
            case 1: {
                switch (index) {
                    case 0:
                        return this.renderLayoutLaunchAddButton()
                    case 1:
                        return pages.selected == 1
                            ? this.renderLayoutAddButtonWishlist()
                            : this.renderLayoutAddButtonCompare()
                    default:
                        return
                }
            }
            case 2: {
                switch (index) {
                    case 0:
                        return this.renderLayoutLaunchAddButtonProductPage()
                    case 1:
                        return pages.selected == 1
                            ? this.renderLayoutAddButtonWishlistProductPage()
                            : this.renderLayoutAddButtonCompareProductPage()
                    case 2:
                        return this.renderSelectorAddButton()
                    default:
                        return
                }
            }
            case 3: {
                switch (index) {
                    case 0:
                        return pages.selected == 1
                            ? this.renderLayoutRemoveButtonWishlist()
                            : this.renderLayoutRemoveButtonCompare()
                    default:
                        return
                }
            }
        }
    }

    changeSetting() {
        console.log("app_settings", this.state.app_settings.wishlist_settings)
        const { actions, pages } = this.props
        if (pages.selected == 1)
            actions.changeAppRenderAction("wishlist", this.state.app_settings.wishlist_settings)
        else actions.changeAppRenderAction("compare", this.state.app_settings.compare_settings)
    }

    handleChangePointType = (name, val) => {
        const { widget_selected, actions, pages } = this.props
        const { app_settings } = this.state
        let newWidget = Object.assign({}, app_settings)
        const { launch_show } =
            pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
        const type = "launch_show"
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        switch (name) {
            case "type":
                launch_show.type = val
                this.setState({ app_settings: newWidget })
                this.cacheSetting(setting_type, {
                    [type]: {
                        ...launch_show,
                    },
                })
                break
            case "placement":
                let position_button = {
                    position: "absolute",
                    text_color: launch_show.position_button.text_color,
                    minWidth: "30px",
                    minHeight: "30px",
                    borderRadius: launch_show.position_button.borderRadius,
                    width: launch_show.position_button.width,
                    height: launch_show.position_button.height,
                }
                if (val == "Bottom Right") {
                    position_button.bottom = "20px"
                    position_button.right = "20px"
                }
                if (val == "Bottom Left") {
                    position_button.bottom = "20px"
                    position_button.left = "20px"
                }
                if (val == "Right") {
                    position_button.top = "50%"
                    position_button.right = "20px"
                }
                if (val == "Left") {
                    position_button.top = "50%"
                    position_button.left = "20px"
                }
                launch_show.placement = val
                position_button.background_color = launch_show.position_button.background_color
                if (launch_show.showBackground) {
                    position_button.boxShadow = "rgb(153, 153, 153) 1px 1px 10px 0px"
                }
                launch_show.position_button = position_button
                this.setState({ app_settings: newWidget })
                this.cacheSetting(setting_type, {
                    [type]: {
                        ...launch_show,
                    },
                })
                break
            default:
                break
        }
    }

    handleChangeSizeBackgroundShow = (name, val) => {
        const { app_settings } = this.state
        const { pages } = this.props
        let newWidget = Object.assign({}, app_settings)
        const { launch_show } =
            pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
        const type = "launch_show"
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        switch (name) {
            case "width":
                launch_show.position_button.width = val
                break
            case "height":
                launch_show.position_button.height = val
                break
            case "radius":
                launch_show.position_button.borderRadius = val
                break
            default:
                break
        }
        this.setState({ app_settings: newWidget })
        this.cacheSetting(setting_type, {
            [type]: {
                ...launch_show,
            },
        })
    }

    handleChangeSizeBackgroundAdd = (name, val) => {
        const { app_settings } = this.state
        const { pages } = this.props
        let newWidget = Object.assign({}, app_settings)
        const { launch_add } =
            pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
        const type = "launch_add"
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        switch (name) {
            case "width":
                launch_add.width = val
                break
            case "height":
                launch_add.height = val
                break
            case "radius":
                launch_add.borderRadius = val
                break
            default:
                break
        }
        this.setState({ app_settings: newWidget })
        this.cacheSetting(setting_type, {
            [type]: {
                ...launch_add,
            },
        })
    }

    handleChangeSizeBackgroundAddProductPage = (name, val) => {
        const { app_settings } = this.state
        const { pages } = this.props
        let newWidget = Object.assign({}, app_settings)
        const { launch_add_product_page } =
            pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
        const type = "launch_add_product_page"
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        switch (name) {
            case "width":
                launch_add_product_page.width = val
                break
            case "height":
                launch_add_product_page.height = val
                break
            case "radius":
                launch_add_product_page.borderRadius = val
                break
            default:
                break
        }
        this.setState({ app_settings: newWidget })
        this.cacheSetting(setting_type, {
            [type]: {
                ...launch_add_product_page,
            },
        })
    }

    renderLayoutLaunchShowButton = () => {
        const { pages } = this.props
        const { app_settings } = this.state
        const { wishlist_settings, compare_settings } = app_settings
        const { launch_show } = pages.selected == 1 ? wishlist_settings : compare_settings
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        const { pointTypeSetting } = this.state
        let link = "https://" + shopOrigin + "/admin/links"
        let link_help = "https://support.arenacommerce.com/support/tickets/new"
        let clientUrl1 = "electro-5-demo.myshopify.com"
        return (
            <div>
                {/* {launch_show.type == "floating" &&
        } */}

                <div className="yta-form-group">
                    <div className="yta-label">HEADER LAYOUT</div>
                    <div className="btn-group">
                        <Stack vertical>
                            <Stack.Item>
                                <ChoiceList
                                    title="Display style"
                                    choices={[
                                        {
                                            label: "As a floating button",
                                            value: "floating",
                                        },
                                        {
                                            label: "As a menu item",
                                            value: "menu",
                                        },
                                        {
                                            label: "As an icon on header",
                                            value: "header",
                                        },
                                    ]}
                                    selected={launch_show.type}
                                    onChange={(val, name) => {
                                        this.handleChangePointType("type", val)
                                    }}
                                />
                            </Stack.Item>
                            {launch_show.type == "floating" ? (
                                <Stack.Item>
                                    <Select
                                        label="Choose a button placement for your site"
                                        options={pointTypeSetting.placement}
                                        onChange={(val) => {
                                            this.handleChangePointType("placement", val)
                                        }}
                                        value={launch_show.placement}
                                    />

                                    <div className="mt-2rem yta-form-group">
                                        <Stack distribution="fillEvenly">
                                            <Stack.Item>
                                                <div className="yta-label">WISHLIST LABEL</div>
                                                <Switch
                                                    height={20}
                                                    width={46}
                                                    onChange={() => {
                                                        let newWidget = Object.assign(
                                                            {},
                                                            app_settings,
                                                        )
                                                        launch_show.showTittle =
                                                            !launch_show.showTittle
                                                        this.setState({ app_settings: newWidget })
                                                        this.cacheSetting(setting_type, {
                                                            ["launch_show"]: {
                                                                ...launch_show,
                                                            },
                                                        })
                                                    }}
                                                    checked={launch_show.showTittle}
                                                />
                                            </Stack.Item>
                                            <Stack.Item>
                                                <div className="yta-label">SHOW BACKGROUND</div>
                                                <Switch
                                                    height={20}
                                                    width={46}
                                                    onChange={() => {
                                                        let newWidget = Object.assign(
                                                            {},
                                                            app_settings,
                                                        )
                                                        launch_show.showBackground =
                                                            !launch_show.showBackground
                                                        if (!launch_show.showBackground) {
                                                            launch_show.position_button.background_color =
                                                                "transparent"
                                                            launch_show.position_button.boxShadow =
                                                                "none"
                                                        } else {
                                                            launch_show.position_button.background_color =
                                                                "#000000"
                                                            launch_show.position_button.boxShadow =
                                                                "rgb(153, 153, 153) 1px 1px 10px 0px"
                                                        }
                                                        this.setState({ app_settings: newWidget })
                                                        this.cacheSetting(setting_type, {
                                                            ["launch_show"]: {
                                                                ...launch_show,
                                                            },
                                                        })
                                                    }}
                                                    checked={launch_show.showBackground}
                                                />
                                            </Stack.Item>
                                        </Stack>
                                    </div>

                                    <div className="mt-2rem">
                                        {launch_show.showTittle && (
                                            <TextField
                                                label={"Name your button label"}
                                                value={launch_show.text}
                                                onChange={(val) => {
                                                    let newWidget = Object.assign({}, app_settings)
                                                    if (pages.selected == 1)
                                                        newWidget.wishlist_settings.launch_show.text =
                                                            val
                                                    else
                                                        newWidget.compare_settings.launch_show.text =
                                                            val
                                                    this.setState({ app_settings: newWidget })
                                                    this.cacheSetting(setting_type, {
                                                        ["launch_show"]: {
                                                            ...launch_show,
                                                        },
                                                    })
                                                }}
                                            />
                                        )}
                                    </div>
                                    {launch_show.showBackground && (
                                        <div className="row-item-wh">
                                            <div className="icon-wh">
                                                <TextField
                                                    label="Border Radius"
                                                    value={launch_show.position_button.borderRadius}
                                                    type="number"
                                                    min={0}
                                                    onChange={(val) =>
                                                        this.handleChangeSizeBackgroundShow(
                                                            "radius",
                                                            val,
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="row-item-wh">
                                        <div className="icon-wh">
                                            <TextField
                                                label="Button Width"
                                                value={launch_show.position_button.width}
                                                type="number"
                                                min={launch_show.showTittle ? 140 : 30}
                                                max={launch_show.showTittle ? 300 : 40}
                                                onChange={(val) =>
                                                    this.handleChangeSizeBackgroundShow(
                                                        "width",
                                                        val,
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="icon-wh">
                                            <TextField
                                                label="Button Height"
                                                value={launch_show.position_button.height}
                                                type="number"
                                                min={30}
                                                max={launch_show.showTittle ? 130 : 40}
                                                onChange={(val) =>
                                                    this.handleChangeSizeBackgroundShow(
                                                        "height",
                                                        val,
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    {this.renderColorsShowButton()}
                                </Stack.Item>
                            ) : launch_show.type == "menu" ? (
                                <Card sectioned title="Please follow the steps given below">
                                    <List type="number">
                                        <List.Item>
                                            Open the main navigation on your shopify site -
                                            <a target="_blank" href={link}>
                                                Open
                                            </a>
                                        </List.Item>
                                        <List.Item>
                                            Select your main menu and click on "Add menu item" to
                                            add a new menu item.
                                        </List.Item>
                                        <List.Item>
                                            Choose a name for the
                                            {pages.selected == 1 ? " Wishlist" : " Compare"}
                                        </List.Item>
                                        <List.Item>
                                            In the text box for Link, paste the following text:
                                            <b>
                                                {pages.selected == 1
                                                    ? " #arn-wishlist"
                                                    : " #arn-compare"}
                                            </b>
                                        </List.Item>
                                        <List.Item>Click on "Save Menu".</List.Item>
                                    </List>
                                </Card>
                            ) : window.parentUrl != clientUrl1 ? (
                                <Card sectioned title="Please follow the steps given below">
                                    <p>
                                        If you are looking to add the{" "}
                                        {pages.selected == 1 ? " Wishlist" : " Compare"} launch
                                        point in your header menu, Please{" "}
                                        <b>
                                            <a target="_blank" href={link_help}>
                                                contact us
                                            </a>
                                        </b>{" "}
                                        to get help since it needs to be added into your theme code.
                                        We will get back to you asap and start the process after
                                        03-08 working days of receiving your ticket.
                                    </p>
                                </Card>
                            ) : (
                                this.renderSelectoShowButton()
                            )}
                        </Stack>
                    </div>
                </div>
            </div>
        )
    }

    renderLayoutLaunchAddButtonProductPage = () => {
        const { app_settings } = this.state
        const { pages } = this.props
        const { wishlist_settings, compare_settings } = app_settings
        const { launch_add_product_page, launch_add } =
            pages.selected == 1 ? wishlist_settings : compare_settings
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        const type = "launch_add_product_page"
        // let link_help = "https://support.arenacommerce.com/support/tickets/new"
        return (
            <div>
                <div className="yta-form-group">
                    <Stack distribution="fillEvenly">
                        {/* SHOW TITLE*/}
                        <Stack.Item>
                            <div className="yta-label">SHOW LABEL</div>
                            <Switch
                                height={20}
                                width={46}
                                onChange={() => {
                                    let newWidget = Object.assign({}, app_settings)
                                    launch_add_product_page.showTittle =
                                        !launch_add_product_page.showTittle
                                    this.setState({ app_settings: newWidget })
                                    this.cacheSetting(setting_type, {
                                        [type]: {
                                            ...launch_add_product_page,
                                        },
                                    })
                                }}
                                checked={launch_add_product_page.showTittle}
                            />
                        </Stack.Item>
                        {/* SHOW BACKGROUND*/}
                        <Stack.Item>
                            <div className="yta-label">SHOW BACKGROUND</div>
                            <Switch
                                height={20}
                                width={46}
                                onChange={() => {
                                    let newWidget = Object.assign({}, app_settings)
                                    launch_add_product_page.showBackground =
                                        !launch_add_product_page.showBackground
                                    if (!launch_add_product_page.showBackground) {
                                        launch_add_product_page.background_color = "transparent"
                                    } else {
                                        launch_add_product_page.background_color = "#EBC9C9"
                                    }
                                    this.setState({ app_settings: newWidget })
                                    this.cacheSetting(setting_type, {
                                        [type]: {
                                            ...launch_add_product_page,
                                        },
                                    })
                                }}
                                checked={launch_add_product_page.showBackground}
                            />
                        </Stack.Item>
                        <div style={{ marginTop: "30px" }}>
                            <Stack.Item>
                                <div className="show-social-count">
                                    {/* SHOW SOCIAL COUNT*/}
                                    {pages.selected == 1 && (
                                        <Stack.Item>
                                            <div className="yta-label">SHOW PRODUCT COUNT</div>
                                            <Switch
                                                disabled={
                                                    this.props.plan.plan == "free" ? true : false
                                                }
                                                height={20}
                                                width={46}
                                                onChange={() => {
                                                    let newWidget = Object.assign({}, app_settings)
                                                    launch_add.showCount = !launch_add.showCount
                                                    this.setState({ app_settings: newWidget })
                                                    this.cacheSetting(setting_type, {
                                                        [type]: {
                                                            ...launch_add,
                                                        },
                                                    })
                                                }}
                                                checked={
                                                    this.props.plan.plan == "free"
                                                        ? false
                                                        : launch_add.showCount
                                                }
                                            />
                                        </Stack.Item>
                                    )}
                                </div>
                            </Stack.Item>
                        </div>
                    </Stack>
                </div>

                <div className="yta-form-group">
                    <div className="yta-label">HEADER LAYOUT</div>
                    {launch_add_product_page.showTittle && (
                        <div className="btn-group">
                            <Stack vertical>
                                <Stack.Item>
                                    <TextField
                                        label={
                                            pages.selected == 1
                                                ? "Button Label Before adding to Wishlist"
                                                : "Button Label Before adding to Compare"
                                        }
                                        value={launch_add_product_page.text}
                                        onChange={(val) => {
                                            let newWidget = Object.assign({}, app_settings)
                                            if (pages.selected == 1)
                                                newWidget.wishlist_settings.launch_add_product_page.text =
                                                    val
                                            else
                                                newWidget.compare_settings.launch_add_product_page.text =
                                                    val
                                            this.setState({ app_settings: newWidget })
                                            this.cacheSetting(setting_type, {
                                                [type]: {
                                                    ...launch_add_product_page,
                                                },
                                            })
                                        }}
                                    />
                                </Stack.Item>
                                <Stack.Item>
                                    <TextField
                                        label={
                                            pages.selected == 1
                                                ? "Button Text After adding to Wishlist"
                                                : "Button Text After adding to Compare"
                                        }
                                        value={launch_add_product_page.text_added}
                                        onChange={(val) => {
                                            let newWidget = Object.assign({}, app_settings)
                                            if (pages.selected == 1)
                                                newWidget.wishlist_settings.launch_add_product_page.text_added =
                                                    val
                                            else
                                                newWidget.compare_settings.launch_add_product_page.text_added =
                                                    val
                                            this.setState({ app_settings: newWidget })
                                            this.cacheSetting(setting_type, {
                                                [type]: {
                                                    ...launch_add_product_page,
                                                },
                                            })
                                        }}
                                    />
                                </Stack.Item>
                            </Stack>
                        </div>
                    )}

                    <div className="row-item-wh">
                        <div className="icon-wh">
                            <TextField
                                label="Border Radius"
                                value={launch_add_product_page.borderRadius}
                                type="number"
                                min={0}
                                onChange={(val) =>
                                    this.handleChangeSizeBackgroundAddProductPage("radius", val)
                                }
                            />
                        </div>
                    </div>
                    <div className="row-item-wh">
                        <div className="icon-wh">
                            <TextField
                                label="Button Width"
                                value={launch_add_product_page.width}
                                type="number"
                                min={launch_add_product_page.showTittle ? 30 : 30}
                                max={launch_add_product_page.showTittle ? 50 : 40}
                                onChange={(val) =>
                                    this.handleChangeSizeBackgroundAddProductPage("width", val)
                                }
                            />
                        </div>
                        <div className="icon-wh">
                            <TextField
                                label="Button Height"
                                value={launch_add_product_page.height}
                                type="number"
                                min={30}
                                max={launch_add_product_page.showTittle ? 50 : 40}
                                onChange={(val) =>
                                    this.handleChangeSizeBackgroundAddProductPage("height", val)
                                }
                            />
                        </div>
                    </div>
                    {this.renderColorsAddButtonProductPage()}
                </div>
            </div>
        )
    }

    renderLayoutLaunchAddButton = () => {
        const { app_settings } = this.state
        const { pages } = this.props
        const { wishlist_settings, compare_settings } = app_settings
        const { launch_add } = pages.selected == 1 ? wishlist_settings : compare_settings
        const setting_type = pages.selected == 1 ? "wishlist" : "compare"
        const type = "launch_add"
        // let link_help = "https://support.arenacommerce.com/support/tickets/new"
        return (
            <div>
                <div className="yta-form-group">
                    <Stack distribution="fillEvenly">
                        {/* SHOW TITLE*/}
                        <Stack.Item>
                            <div className="yta-label">SHOW LABEL</div>
                            <Switch
                                height={20}
                                width={46}
                                onChange={() => {
                                    let newWidget = Object.assign({}, app_settings)
                                    launch_add.showTittle = !launch_add.showTittle
                                    this.setState({ app_settings: newWidget })
                                    this.cacheSetting(setting_type, {
                                        [type]: {
                                            ...launch_add,
                                        },
                                    })
                                }}
                                checked={launch_add.showTittle}
                            />
                        </Stack.Item>
                        {/* SHOW BACKGROUND*/}
                        <Stack.Item>
                            <div className="yta-label">SHOW BACKGROUND</div>
                            <Switch
                                height={20}
                                width={46}
                                onChange={() => {
                                    let newWidget = Object.assign({}, app_settings)
                                    launch_add.showBackground = !launch_add.showBackground
                                    if (!launch_add.showBackground) {
                                        launch_add.background_color = "transparent"
                                    } else {
                                        launch_add.background_color = "#EBC9C9"
                                    }
                                    this.setState({ app_settings: newWidget })
                                    this.cacheSetting(setting_type, {
                                        [type]: {
                                            ...launch_add,
                                        },
                                    })
                                }}
                                checked={launch_add.showBackground}
                            />
                        </Stack.Item>
                    </Stack>
                </div>

                <div className="yta-form-group">
                    <div className="yta-label">HEADER LAYOUT</div>
                    {launch_add.showTittle && (
                        <div className="btn-group">
                            <Stack vertical>
                                <Stack.Item>
                                    <TextField
                                        label={
                                            pages.selected == 1
                                                ? "Button Text Before adding to Wishlist"
                                                : "Button Text Before adding to Compare"
                                        }
                                        value={launch_add.text}
                                        onChange={(val) => {
                                            let newWidget = Object.assign({}, app_settings)
                                            if (pages.selected == 1)
                                                newWidget.wishlist_settings.launch_add.text = val
                                            else newWidget.compare_settings.launch_add.text = val
                                            this.setState({ app_settings: newWidget })
                                            this.cacheSetting(setting_type, {
                                                [type]: {
                                                    ...launch_add,
                                                },
                                            })
                                        }}
                                    />
                                </Stack.Item>
                                <Stack.Item>
                                    <TextField
                                        label={
                                            pages.selected == 1
                                                ? "Button Text After adding to Wishlist"
                                                : "Button Text After adding to Compare"
                                        }
                                        value={launch_add.text_added}
                                        onChange={(val) => {
                                            let newWidget = Object.assign({}, app_settings)
                                            if (pages.selected == 1)
                                                newWidget.wishlist_settings.launch_add.text_added =
                                                    val
                                            else
                                                newWidget.compare_settings.launch_add.text_added =
                                                    val
                                            this.setState({ app_settings: newWidget })
                                            this.cacheSetting(setting_type, {
                                                [type]: {
                                                    ...launch_add,
                                                },
                                            })
                                        }}
                                    />
                                </Stack.Item>
                            </Stack>
                        </div>
                    )}
                    {launch_add.showBackground && (
                        <div className="row-item-wh">
                            <div className="icon-wh">
                                <TextField
                                    label="Border Radius"
                                    value={launch_add.borderRadius}
                                    type="number"
                                    min={0}
                                    onChange={(val) =>
                                        this.handleChangeSizeBackgroundAdd("radius", val)
                                    }
                                />
                            </div>
                        </div>
                    )}
                    <div className="row-item-wh">
                        <div className="icon-wh">
                            <TextField
                                label="Button Width"
                                value={launch_add.width}
                                type="number"
                                min={launch_add.showTittle ? 30 : 30}
                                max={launch_add.showTittle ? 50 : 40}
                                onChange={(val) => this.handleChangeSizeBackgroundAdd("width", val)}
                            />
                        </div>
                        <div className="icon-wh">
                            <TextField
                                label="Button Height"
                                value={launch_add.height}
                                type="number"
                                min={30}
                                max={launch_add.showTittle ? 50 : 40}
                                onChange={(val) =>
                                    this.handleChangeSizeBackgroundAdd("height", val)
                                }
                            />
                        </div>
                    </div>
                    {this.renderColorsAddButton()}
                </div>
            </div>
        )
    }

    renderLayoutAddButtonWishlistProductPage = () => {
        const { app_settings } = this.state
        const { wishlist_settings } = app_settings
        const { iconsSet, errorValidate } = this.state
        return (
            <div>
                <hr />
                {/** Add to wishlist class name */}
                <Heading>Class name for Add to Wishlist Button</Heading>
                <TextField
                    value={wishlist_settings.wishlist_add_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    //'(\.(?!\s|,).*,\s*)*\.(?!\s|,).*[a-zA-Z0-9]+$'
                    error={errorValidate.error_1}
                    onChange={(val) => {
                        this.addClassSettings(val, "wishlist")
                    }}
                />
                {/** Predefined Icons for wishlist -- Add */}
                <IconList
                    iconList={iconsSet.wishlist}
                    setting={wishlist_settings.add_class_icon_product}
                    iconKey="arn_icon-add-wishlist"
                    settingType="wishlist_settings"
                    iconType="add_class_icon_product"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    renderLayoutAddButtonWishlist = () => {
        const { app_settings } = this.state
        const { wishlist_settings } = app_settings
        const { iconsSet, errorValidate } = this.state
        return (
            <div>
                <hr />
                {/** Add to wishlist class name */}
                <Heading>Class name for Add to Wishlist Button</Heading>
                <TextField
                    value={wishlist_settings.wishlist_add_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    //'(\.(?!\s|,).*,\s*)*\.(?!\s|,).*[a-zA-Z0-9]+$'
                    error={errorValidate.error_1}
                    onChange={(val) => {
                        this.addClassSettings(val, "wishlist")
                    }}
                />
                {/** Predefined Icons for wishlist -- Add */}
                <IconList
                    iconList={iconsSet.wishlist}
                    setting={wishlist_settings.add_class_icon}
                    iconKey="arn_icon-add-wishlist"
                    settingType="wishlist_settings"
                    iconType="add_class_icon"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    selector(name) {
        const { product } = this.state
        let url = new URL(window.location.href)
        let c = url.searchParams.get("shop")
        window.open(`https://${c}/products/${product.handle}?${name}=1`)
    }

    handleCustomCss(val: String) {
        // if (type === "wishlist") {
        //     this.setState({
        //         app_settings: {
        //             ...this.state.app_settings,
        //             wishlist_settings: {
        //                 ...this.state.app_settings.wishlist_settings,
        //                 customCss: val,
        //             },
        //         },
        //     })
        //     // Cache edited setting
        //     this.cacheSetting("wishlist", { customCss: val })
        // } else {
        //     this.setState({
        //         app_settings: {
        //             ...this.state.app_settings,
        //             compare_settings: {
        //                 ...this.state.app_settings.compare_settings,
        //                 customCss: val,
        //             },
        //         },
        //     })
        //     // Cache edited setting
        //     this.cacheSetting("compare", { customCss: val })
        // }
        this.setState({ customCss: val })
    }

    updateCustomCss = () => {
        let customCss = this.state.customCss
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/update-metafields-custom-css`, { customCss })
            .then((res) => {
                console.log("res :>> ", res)
            })
    }

    renderSelectoShowButton = () => {
        const { app_settings, errorValidate, selectorTypeSetting } = this.state
        const { wishlist_settings, compare_settings } = app_settings
        const { widget_selected, pages } = this.props
        let selector =
            pages.selected == 1 ? wishlist_settings.show_selector : compare_settings.show_selector
        let name = pages.selected == 1 ? "show-wishlist" : "show-compare"
        let type = pages.selected == 1 ? "wishlist" : "compare"
        const link_help1 =
            "https://support.arenacommerce.com/support/solutions/articles/6000243479-how-to-modify-the-wishlist-compare-buttons"

        window.onfocus = () => {
            if (window.check) {
                axios
                    .get(`${window.SHOPIFY_APP_HOST}/admin/load-app-settings`)
                    .then((response) => {
                        const resObj = response.data
                        if (resObj.status === "error") {
                            throw new Error(resObj.msg)
                        } else {
                            let appSettings = JSON.parse(resObj.settings[0].value)
                            this.updateSelector(
                                appSettings.wishlist_settings.show_selector.selector_class,
                                "selector_class",
                                type,
                            )
                            this.setState({ app_settings: appSettings })
                        }
                    })
                    .catch((err) => {
                        console.log("err :>> ", err)
                    })
                window.check = false
            }
        }
        window.onblur = function () {
            window.check = true
        }
        return (
            <div>
                <Heading>Page Selector</Heading>
                <Stack distribution="fillEvenly">
                    <Button onClick={() => this.selector(name)}>Selector</Button>
                    <div className="btn-title">
                        <a className="tooltip" target="_blank" href={link_help1} rel="noopener">
                            <Icon source={QuestionMarkMinor} color="subdued" />
                            <span className="tooltiptext">How to work</span>
                        </a>
                    </div>
                </Stack>

                <div style={{ marginTop: "30px" }}></div>
                <TextField
                    value={selector.selector_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    //'(\.(?!\s|,).*,\s*)*\.(?!\s|,).*[a-zA-Z0-9]+$'
                    error={errorValidate.error_1}
                    onChange={(val) => {
                        this.updateSelector(val, "selector_class", type)
                    }}
                />
                <div className="mt-10">
                    <Heading>Choose a button placement for your site</Heading>
                    <Select
                        label=""
                        options={selectorTypeSetting.placement}
                        onChange={(val) => {
                            this.updateSelector(val, "type", type)
                        }}
                        value={selector.type}
                    />
                </div>
                <div className="mt-10">
                    <Heading>Margin</Heading>
                    <TextField
                        helpText="Ex (10px 10px 0px 0px)"
                        value={typeof selector.margin !== 'undefined' ? selector.margin : '0'}
                        placeholder="(top right bottom left)"
                        error={errorValidate.error_1}
                        onChange={(val) => {
                            this.updateSelector(val, "margin", type)
                        }}
                    />
                </div>
                {/* <div className="mt-10">
                    <Heading>Padding</Heading>
                    <TextField
                        helpText="Ex (10px 10px 0px 0px)"
                        value={selector.padding}
                        placeholder="(top right bottom left)"
                        error={errorValidate.error_1}
                        onChange={(val) => {
                            this.updateSelector(val, "padding", type)
                        }}
                    />
                </div> */}
            </div>
        )
    }

    renderSelectorAddButton = () => {
        const { app_settings, errorValidate, selectorTypeSetting } = this.state
        const { wishlist_settings, compare_settings } = app_settings
        const { widget_selected, pages } = this.props
        let selector =
            pages.selected == 1 ? wishlist_settings.add_selector : compare_settings.add_selector
        let name = pages.selected == 1 ? "add-wishlist" : "add-compare"
        let type = pages.selected == 1 ? "wishlist" : "compare"
        const link_help1 =
            "https://support.arenacommerce.com/support/solutions/articles/6000243479-how-to-modify-the-wishlist-compare-buttons"

        const { customCss } = this.state
        window.onfocus = () => {
            if (window.check) {
                axios
                    .get(`${window.SHOPIFY_APP_HOST}/admin/load-app-settings`)
                    .then((response) => {
                        const resObj = response.data
                        if (resObj.status === "error") {
                            throw new Error(resObj.msg)
                        } else {
                            let appSettings = JSON.parse(resObj.settings[0].value)
                            this.updateSelector(
                                appSettings.wishlist_settings.add_selector.selector_class,
                                "selector_class",
                                type,
                            )
                            this.setState({ app_settings: appSettings })
                        }
                    })
                    .catch((err) => {
                        console.log("err :>> ", err)
                    })
                window.check = false
            }
        }
        window.onblur = function () {
            window.check = true
        }
        return (
            <div>
                <Heading>Page Selector</Heading>
                <Stack distribution="fillEvenly">
                    <Button onClick={() => this.selector(name)}>Selector</Button>
                    <div className="btn-title">
                        <a className="tooltip" target="_blank" href={link_help1} rel="noopener">
                            <Icon source={QuestionMarkMinor} color="subdued" />
                            <span className="tooltiptext">How to work</span>
                        </a>
                    </div>
                </Stack>

                <div style={{ marginTop: "30px" }}></div>
                <TextField
                    value={selector.selector_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    //'(\.(?!\s|,).*,\s*)*\.(?!\s|,).*[a-zA-Z0-9]+$'
                    error={errorValidate.error_1}
                    onChange={(val) => {
                        this.updateSelector(val, "selector_class", type)
                    }}
                />
                <div className="mt-10">
                    <Heading>Choose a button placement for your site</Heading>
                    <Select
                        label=""
                        options={selectorTypeSetting.placement}
                        onChange={(val) => {
                            this.updateSelector(val, "type", type)
                        }}
                        value={selector.type}
                    />
                </div>
                <div className="mt-10">
                    <Heading>Margin</Heading>
                    <TextField
                        helpText="Ex (10px 10px 0px 0px)"
                        value={selector.margin}
                        placeholder="(top right bottom left)"
                        error={errorValidate.error_1}
                        onChange={(val) => {
                            this.updateSelector(val, "margin", type)
                        }}
                    />
                </div>
                <div className="mt-10">
                    <Heading>Padding</Heading>
                    <TextField
                        helpText="Ex (10px 10px 0px 0px)"
                        value={typeof selector.padding !== 'undefined' ? selector.padding : '0'}
                        placeholder="(top right bottom left)"
                        error={errorValidate.error_1}
                        onChange={(val) => {
                            this.updateSelector(val, "padding", type)
                        }}
                    />
                </div>
                {/* <div>
                    <TextField
                        label="Custom CSS"
                        value={customCss}
                        onChange={(val) => this.handleCustomCss(val, type)}
                        multiline={4}
                    />

                    <div style={{ marginTop: "30px" }}>
                        <Button onClick={() => this.updateCustomCss()}>Save Custom CSS</Button>
                    </div>
                </div> */}
            </div>
        )
    }

    renderLayoutShowButtonWishlist = () => {
        const { app_settings } = this.state
        const { wishlist_settings } = app_settings
        const { iconsSet, errorValidate } = this.state

        return (
            <div>
                <Heading>Class name for show wishlist button</Heading>
                <TextField
                    value={wishlist_settings.wishlist_show_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    error={errorValidate.error_2}
                    onChange={(val) => {
                        this.showClassSettings(val, "wishlist")
                    }}
                />
                {/** Predefined Icons for wishlist -- Show */}
                <IconList
                    iconList={iconsSet.wishlist}
                    setting={wishlist_settings.show_class_icon}
                    iconKey="arn_icon-show-wishlist"
                    settingType="wishlist_settings"
                    iconType="show_class_icon"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    renderLayoutAddButtonCompareProductPage = () => {
        const { app_settings } = this.state
        const { compare_settings } = app_settings
        const { iconsSet, errorValidate } = this.state
        return (
            <div>
                <hr />
                <Heading>Class name for Add to Compare Button</Heading>
                <TextField
                    value={compare_settings.compare_add_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    error={errorValidate.error_3}
                    onChange={(val) => {
                        this.addClassSettings(val, "compare")
                    }}
                />
                {/** Predefined Icons for compare -- Add */}
                <IconList
                    iconList={iconsSet.compare}
                    setting={compare_settings.add_class_icon_product}
                    iconKey="arn_icon-add-compare"
                    settingType="compare_settings"
                    iconType="add_class_icon_product"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    renderLayoutAddButtonCompare = () => {
        const { app_settings } = this.state
        const { compare_settings } = app_settings
        const { iconsSet, errorValidate } = this.state
        return (
            <div>
                <hr />
                <Heading>Class name for Add to Compare Button</Heading>
                <TextField
                    value={compare_settings.compare_add_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    error={errorValidate.error_3}
                    onChange={(val) => {
                        this.addClassSettings(val, "compare")
                    }}
                />
                {/** Predefined Icons for compare -- Add */}
                <IconList
                    iconList={iconsSet.compare}
                    setting={compare_settings.add_class_icon}
                    iconKey="arn_icon-add-compare"
                    settingType="compare_settings"
                    iconType="add_class_icon"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    renderLayoutShowButtonCompare = () => {
        const { app_settings } = this.state
        const { compare_settings } = app_settings
        const { iconsSet, errorValidate } = this.state

        return (
            <div>
                <Heading>Class name for show compare button</Heading>
                <TextField
                    value={compare_settings.compare_show_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    error={errorValidate.error_4}
                    onChange={(val) => {
                        this.showClassSettings(val, "compare")
                    }}
                />
                {/** Predefined Icons for compare -- Show */}
                <IconList
                    iconList={iconsSet.compare}
                    setting={compare_settings.show_class_icon}
                    iconKey="arn_icon-show-compare"
                    settingType="compare_settings"
                    iconType="show_class_icon"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    renderLayoutRemoveButtonWishlist = () => {
        const { app_settings } = this.state
        const { wishlist_settings } = app_settings
        const { iconsSet, errorValidate } = this.state
        return (
            <div>
                <Heading>Class name for remove wishlist button</Heading>
                <TextField
                    value={wishlist_settings.wishlist_remove_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    error={errorValidate.error_2a}
                    onChange={(val) => {
                        this.removeClassSettings(val, "wishlist")
                    }}
                />
                {/** Predefined Icons for wishlist -- Remove */}
                <IconList
                    iconList={iconsSet.remove}
                    setting={wishlist_settings.remove_class_icon}
                    iconKey="arn_icon-remove-wishlist"
                    settingType="wishlist_settings"
                    iconType="remove_class_icon"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    renderLayoutRemoveButtonCompare = () => {
        const { app_settings } = this.state
        const { compare_settings } = app_settings
        const { iconsSet, errorValidate } = this.state
        return (
            <div>
                <Heading>Class name for remove compare button</Heading>
                <TextField
                    value={compare_settings.compare_remove_class}
                    placeholder='Class name must contains alphabet, number, underscore "_" and dash "-" characters.'
                    error={errorValidate.error_4a}
                    onChange={(val) => {
                        this.removeClassSettings(val, "compare")
                    }}
                />
                {/** Predefined Icons for compare -- Remove */}
                <IconList
                    iconList={iconsSet.remove}
                    setting={compare_settings.remove_class_icon}
                    iconKey="arn_icon-remove-compare"
                    settingType="compare_settings"
                    iconType="remove_class_icon"
                    updateIcon={this.updateIconSettings.bind(this)}
                />
            </div>
        )
    }

    addMode(val) {
        const { app_settings } = this.state
        const { pages } = this.props
        const { wishlist_settings, compare_settings } = app_settings
        const { launch_add } = pages.selected == 1 ? wishlist_settings : compare_settings
        let newWidget = Object.assign({}, app_settings)
        launch_add.check_add_variant = val
        this.setState({ app_settings: newWidget })
        const type = "launch_add"
        this.cacheSetting("wishlist", {
            [type]: {
                ...launch_add,
            },
        })
    }

    appProxyChange(val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                wishlist_settings: {
                    ...this.state.app_settings.wishlist_settings,
                    wishlist_layout: val,
                },
            },
        })
        // Cache edited setting
        this.cacheSetting("wishlist", { wishlist_layout: val })
    }

    renderLayoutAppearanceWishlist = () => {
        const { app_settings } = this.state
        const { wishlist_settings } = app_settings
        const { pages } = this.props
        const { launch_add } = wishlist_settings
        const setting_type = "wishlist"
        const type = "launch_add"
        console.log("props.plan", this.props.plan)
        const disableStyle =
            this.props.plan.plan == "free" ? { opacity: 0.5, pointerEvents: "none" } : {}
        return (
            <div className="yta-form-group">
                <div className="advanced">
                    <div style={disableStyle}>
                        <Heading>App proxy page</Heading>
                        <RadioButton
                            disabled
                            label="App proxy"
                            helpText='App will use proxy to get content of wishlist. If you have your own domain applied to your store and wishlist function cannot work. Please choose "Store Page" option instead.'
                            checked={wishlist_settings.wishlist_layout == "proxy"}
                            name="app_proxy"
                            value="proxy"
                            // onChange={this.appProxyChange.bind(this, "proxy")}
                        />
                        <div style={{ marginTop: "30px" }}>
                            <Stack.Item>
                                <div className="show-social-count">
                                    {/* SHOW SOCIAL COUNT*/}
                                    {pages.selected == 1 && (
                                        <Stack.Item>
                                            <div className="yta-label">SHOW PRODUCT COUNT</div>
                                            <Switch
                                                disabled={
                                                    this.props.plan.plan == "free" ? true : false
                                                }
                                                height={20}
                                                width={46}
                                                onChange={() => {
                                                    let newWidget = Object.assign({}, app_settings)
                                                    launch_add.showCount = !launch_add.showCount
                                                    this.setState({ app_settings: newWidget })
                                                    this.cacheSetting(setting_type, {
                                                        [type]: {
                                                            ...launch_add,
                                                        },
                                                    })
                                                }}
                                                checked={
                                                    this.props.plan.plan == "free"
                                                        ? false
                                                        : launch_add.showCount
                                                }
                                            />
                                        </Stack.Item>
                                    )}
                                </div>
                            </Stack.Item>
                        </div>
                    </div>

                    {this.props.plan.plan == "free" && (
                        <span className="tooltiptext">Please upgrade to use this feature</span>
                    )}
                </div>
            </div>
        )
    }
    _renderLayoutItem = (layoutTabs, item, index) => {
        return (
            <div key={index}>
                <div
                    className="btn-collapse"
                    onClick={() => {
                        let newLayoutTabs = [...layoutTabs]
                        for (let i = 0; i < newLayoutTabs.length; i++) {
                            if (i !== index) {
                                newLayoutTabs[i].show = false
                            } else {
                                newLayoutTabs[i].show = !layoutTabs[i].show
                            }
                        }
                        this.setState({ layoutTabs: newLayoutTabs })
                    }}
                >
                    <span>{item.label}</span>
                    <div className={layoutTabs[index].show ? "icon icon-down" : "icon"} />
                </div>

                <div className="collapse-block">
                    {Boolean(layoutTabs[index].show) && this.rendenLayoutCollapse(index)}
                </div>
            </div>
        )
    }

    renderLayout = () => {
        const { layoutTabs, app_settings } = this.state
        return (
            <div className="layout">
                {layoutTabs.map((item, index) => this._renderLayoutItem(layoutTabs, item, index))}
            </div>
        )
    }

    handleChangeColorButton = (name, e) => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        this.searchTimeout = setTimeout(() => {
            const { app_settings } = this.state
            let newWidget = Object.assign({}, app_settings)
            const { pages } = this.props
            const { launch_add, launch_show } =
                pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
            const setting_type = pages.selected == 1 ? "wishlist" : "compare"
            switch (name) {
                case "show_bg":
                    launch_show.position_button.background_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_show"]: {
                            ...launch_show,
                        },
                    })
                    break
                case "show_text":
                    launch_show.position_button.text_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_show"]: {
                            ...launch_show,
                        },
                    })
                    break
                case "add_bg":
                    launch_add.background_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_add"]: {
                            ...launch_add,
                        },
                    })
                    break
                case "add_text":
                    launch_add.text_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_add"]: {
                            ...launch_add,
                        },
                    })
                    break
                case "add_bg_actived":
                    launch_add.background_color_actived = e
                    this.cacheSetting(setting_type, {
                        ["launch_add"]: {
                            ...launch_add,
                        },
                    })
                    break
                case "add_text_actived":
                    launch_add.text_color_actived = e
                    this.cacheSetting(setting_type, {
                        ["launch_add"]: {
                            ...launch_add,
                        },
                    })
                    break
                default:
                    break
            }
            this.setState({ app_settings: newWidget })
        }, 200)
    }

    handleChangeColorButtonProductPage = (name, e) => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        this.searchTimeout = setTimeout(() => {
            const { app_settings } = this.state
            let newWidget = Object.assign({}, app_settings)
            const { pages } = this.props
            const { launch_add_product_page, launch_show } =
                pages.selected == 1 ? newWidget.wishlist_settings : newWidget.compare_settings
            const setting_type = pages.selected == 1 ? "wishlist" : "compare"
            switch (name) {
                case "show_bg":
                    launch_show.position_button.background_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_show"]: {
                            ...launch_show,
                        },
                    })
                    break
                case "show_text":
                    launch_show.position_button.text_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_show"]: {
                            ...launch_show,
                        },
                    })
                    break
                case "add_bg":
                    launch_add_product_page.background_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_add_product_page"]: {
                            ...launch_add_product_page,
                        },
                    })
                    break
                case "add_text":
                    launch_add_product_page.text_color = e
                    this.cacheSetting(setting_type, {
                        ["launch_add_product_page"]: {
                            ...launch_add_product_page,
                        },
                    })
                    break
                case "add_bg_actived":
                    launch_add_product_page.background_color_actived = e
                    this.cacheSetting(setting_type, {
                        ["launch_add_product_page"]: {
                            ...launch_add_product_page,
                        },
                    })
                    break
                case "add_text_actived":
                    launch_add_product_page.text_color_actived = e
                    this.cacheSetting(setting_type, {
                        ["launch_add_product_page"]: {
                            ...launch_add_product_page,
                        },
                    })
                    break
                default:
                    break
            }
            this.setState({ app_settings: newWidget })
        }, 200)
    }

    renderColorsShowButton = () => {
        const { pages } = this.props
        const { wishlist_settings, compare_settings } = this.state.app_settings
        const { launch_show } = pages.selected == 1 ? wishlist_settings : compare_settings
        return (
            <div className="row-item-wh">
                {launch_show.showBackground && (
                    <ColorSettings
                        text="Background"
                        color={launch_show.position_button.background_color}
                        changeColor={(val) => this.handleChangeColorButton("show_bg", val)}
                    />
                )}
                {launch_show.showTittle && (
                    <ColorSettings
                        text="text"
                        color={launch_show.position_button.text_color}
                        changeColor={(val) => this.handleChangeColorButton("show_text", val)}
                    />
                )}
            </div>
        )
    }

    renderColorsAddButtonProductPage = () => {
        const { pages } = this.props
        const { wishlist_settings, compare_settings } = this.state.app_settings
        const { launch_add_product_page } =
            pages.selected == 1 ? wishlist_settings : compare_settings
        return (
            <div>
                <div className="row-item-wh">
                    {launch_add_product_page.showBackground && (
                        <ColorSettings
                            text="Background"
                            color={launch_add_product_page.background_color}
                            changeColor={(val) =>
                                this.handleChangeColorButtonProductPage("add_bg", val)
                            }
                        />
                    )}
                    {launch_add_product_page.showTittle && (
                        <ColorSettings
                            text="text"
                            color={launch_add_product_page.text_color}
                            changeColor={(val) =>
                                this.handleChangeColorButtonProductPage("add_text", val)
                            }
                        />
                    )}
                </div>

                <div className="row-item-wh">
                    {launch_add_product_page.showBackground && (
                        <ColorSettings
                            text="actived background"
                            color={launch_add_product_page.background_color_actived}
                            changeColor={(val) =>
                                this.handleChangeColorButtonProductPage("add_bg_actived", val)
                            }
                        />
                    )}
                    {launch_add_product_page.showTittle && (
                        <ColorSettings
                            text="actived text"
                            color={launch_add_product_page.text_color_actived}
                            changeColor={(val) =>
                                this.handleChangeColorButtonProductPage("add_text_actived", val)
                            }
                        />
                    )}
                </div>
            </div>
        )
    }

    renderColorsAddButton = () => {
        const { pages } = this.props
        const { wishlist_settings, compare_settings } = this.state.app_settings
        const { launch_add } = pages.selected == 1 ? wishlist_settings : compare_settings
        return (
            <div>
                <div className="row-item-wh">
                    {launch_add.showBackground && (
                        <ColorSettings
                            text="Background"
                            color={launch_add.background_color}
                            changeColor={(val) => this.handleChangeColorButton("add_bg", val)}
                        />
                    )}
                    {launch_add.showTittle && (
                        <ColorSettings
                            text="text"
                            color={launch_add.text_color}
                            changeColor={(val) => this.handleChangeColorButton("add_text", val)}
                        />
                    )}
                </div>

                <div className="row-item-wh">
                    {launch_add.showBackground && (
                        <ColorSettings
                            text="actived background"
                            color={launch_add.background_color_actived}
                            changeColor={(val) =>
                                this.handleChangeColorButton("add_bg_actived", val)
                            }
                        />
                    )}
                    {launch_add.showTittle && (
                        <ColorSettings
                            text="actived text"
                            color={launch_add.text_color_actived}
                            changeColor={(val) =>
                                this.handleChangeColorButton("add_text_actived", val)
                            }
                        />
                    )}
                </div>
            </div>
        )
    }

    renderAdvanced = () => {
        const { advancedTabs, app_settings } = this.state
        return <div className="layout">{this._renderAdvancedItem(advancedTabs)}</div>
    }

    _renderAdvancedItem = (advancedTabs) => {
        return (
            <div>
                <div
                    className="btn-collapse"
                    onClick={() => {
                        let newAdvancedTabs = { ...advancedTabs }
                        newAdvancedTabs.show = !advancedTabs.show
                        this.setState({ advancedTabs: newAdvancedTabs })
                        // this.handleChangeShowRightLayout(index);
                    }}
                >
                    <span>{advancedTabs.label}</span>
                    <div className={advancedTabs.show ? "icon icon-down" : "icon"} />
                </div>

                <div className="collapse-block">
                    {Boolean(advancedTabs.show) && this.rendenAdvancedCollapse()}
                </div>
            </div>
        )
    }
    rendenAdvancedCollapse = () => {
        return this.renderLayoutAppearanceWishlist()
    }

    render() {
        const { goBack, widgets, widget_selected, pages } = this.props
        const { tabSelected, isLoading, toast } = this.state
        const tabs = ["Layout"]
        // if (widget_selected.id == 1) {
        //     if (pages.selected == 1) {
        //         tabs.push("Advanced")
        //     }
        // }
        // if (window.parentUrl.includes("electro-5-demo.myshopify.com")) {
        //     if (widget_selected.id == 1) {
        //         tabs.push("Selector")
        //     }
        // }
        return (
            <div className="template-custom">
                {isLoading && <Preloader />}

                <div
                    className={
                        widget_selected.id == 0 || widget_selected.id == 2 || pages.selected == 2
                            ? "tabs-show"
                            : "tabs"
                    }
                >
                    {tabs.map((item, index) => (
                        <div
                            key={index}
                            className={tabSelected === index ? "tab tab-selected" : "tab"}
                            onClick={() =>
                                index !== tabSelected ? this.setState({ tabSelected: index }) : null
                            }
                        >
                            <div className="tab-body">{item}</div>
                        </div>
                    ))}
                </div>

                <div className="template-custom-body">{this.renderTabComponent()}</div>

                <div
                    className="yta-btn-back"
                    onClick={() => {
                        window.scrollTo(0, widgets.length > 1 ? 500 : 750)
                        goBack()
                    }}
                >
                    Back
                </div>

                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateCustom)
